import type { InfoDoc } from '../infoContent';

/**
 * マニュアル（操作ガイド）。本サービスの実機能に基づく利用案内。
 * 機能追加・変更時はここを更新する。
 */
export const MANUAL_DOC: InfoDoc = {
  title: 'マニュアル',
  sections: [
    {
      body: [
        'ChocoMesse（チョコメッセ）は、合言葉でつながる二人専用のチャットサービスです。会員登録なしでも、合言葉（パスワード）とニックネームを決めるだけですぐに利用できます。本マニュアルでは、基本的な使い方と便利な機能をご案内します。',
      ],
    },
    {
      heading: '1. はじめかた（登録不要）',
      body: [
        '・「合言葉」と「ニックネーム」を入力して入室します。',
        '・相手にも同じ「合言葉」を伝えます（ニックネームはお互い自由に決められます）。',
        '・相手が同じ合言葉で入室すると、リアルタイムでチャットが始まります。',
        '・ルームには最大2名までしか入室できないため、第三者に会話を覗かれる心配がありません。',
      ],
    },
    {
      heading: '2. アカウント登録でできること',
      body: [
        '・アカウント登録は任意です。登録すると、作成した部屋を専用のダッシュボードで一括管理できます。',
        '・各部屋の未読件数の確認、既読表示の切り替え、ゲストのメッセージ数制限、NGワード設定、テンプレート登録などが利用できるようになります。',
        '・ゲスト（登録なし）で使い始めた部屋も、後からログインして「部屋に参加」（同じ合言葉）で登録すれば、ダッシュボードに追加できます。ゲスト時と同じニックネームを使うとスムーズです。',
        '・ただし、ゲストで作成された部屋には「オーナー」が存在しないため、後から参加してもオーナーにはなれません。お知らせ・ゲストのメッセージ数制限・NGワード・テンプレート・部屋の完全削除といったオーナー専用機能は使えず、できるのは自分用の設定（表示名・ブロック・既読表示）の変更と退室のみです。オーナーとして管理したい場合は、最初からログインして「新しい部屋を作成」してください。',
      ],
    },
    {
      heading: '3. ダッシュボードの使い方',
      body: [
        '・ログイン後のダッシュボードでは、管理している部屋の一覧と未読件数を確認できます。',
        '・「部屋に参加」から既存の合言葉で入室、「新しい部屋」から部屋を作成できます。',
      ],
    },
    {
      heading: '4. チャット画面の使い方',
      body: [
        '・画面下部の入力欄からメッセージを送信します。',
        '・登録済みのテンプレートがある場合は、ワンタップで定型文を挿入できます。',
        '・相手が既読にしたメッセージには既読表示が付きます（相手が既読表示をオフにしている場合は表示されません）。',
        '・再読み込みボタンで最新のメッセージを取得できます。',
        '・「退室」でルームから退出します。',
      ],
    },
    {
      heading: '5. メニューの使い方（画面左上）',
      body: [
        '・「テーマ」で画面の配色を切り替えられます。',
        '・「アイコン設定」で、ホーム画面に追加したときのアイコンを変更できます（チャットアプリと気づかれにくいデザインも選べます）。',
        '・「マニュアル」「利用規約」「プライバシーポリシー」をいつでも確認できます。',
      ],
    },
    {
      heading: '6. オーナー向けの管理機能',
      body: [
        '・既読表示のオン／オフを部屋ごとに切り替えられます。',
        '・ゲストの連続送信数に上限を設定できます。',
        '・NGワードを登録すると、該当するメッセージを自動でブロックします。',
        '・お知らせ（アナウンス）を表示できます。',
        '・よく使うメッセージをテンプレートとして登録できます。',
      ],
    },
    {
      heading: '7. 会話を終わらせたいとき',
      body: [
        '・「合言葉だけを変更する」機能はありません。別の合言葉で始めると新しい部屋になり、前の部屋には戻らずにやり取りをリセットできます。',
        '・ただし前の部屋と会話履歴はサーバー上に残り、その合言葉を知っている相手は引き続きアクセスできます。',
        '・履歴ごと完全に消したい場合は、ログインして部屋を作成したオーナーがマイページから「部屋を削除」してください（ゲスト利用では削除できません）。',
        '・相手にブロックを気づかれることなく、綺麗に連絡を断つことができます。',
      ],
    },
    {
      heading: '8. 安全にご利用いただくために',
      body: [
        '・合言葉は、お互いしか知らない言葉にし、信頼できる相手にのみ共有してください。',
        '・合言葉が第三者に知られると、その人もルームに入室できてしまいます。',
        '・「二人専用」は、新しいニックネームでの3人目の入室を拒否する仕組みです。合言葉に加えて参加者のニックネームまで第三者に知られると、その参加者として入室（会話履歴の閲覧やメッセージの送信）ができてしまいます。合言葉だけでなくニックネームも安易に教えないでください。',
        '・合言葉は端末側で暗号化（ハッシュ化）されてから送信され、サーバーには平文で保存されません。',
      ],
    },
  ],
};
